import { Skeleton } from "@/components/ui/skeleton";
import type { HTMLAttributes } from "react";

export const LoadingMyEntry = (props: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className="min-h-screen bg-blue w-full" {...props}>
      <div className="flex flex-col pt-8 pb-4 px-4">
        <Skeleton className="w-full h-6 bg-white" />
      </div>

      {[...Array(4)].map((_, index) => (
        <div key={index} className="flex flex-col m-4 p-4 bg-white">
          <div>
            <Skeleton className="h-5 w-64 mb-2" />
            <div className="flex items-center gap-5">
              <Skeleton className="w-full h-4" />
              <Skeleton className="w-full h-4" />
              <Skeleton className="w-full h-4" />
            </div>

            <div className="flex items-center gap-5 py-4">
              <Skeleton className="w-full h-4" />
              <Skeleton className="w-full h-4" />
              <Skeleton className="w-full h-4" />
            </div>

            <div className="flex gap-2 text-[12px]">
              <Skeleton className="w-1/3 h-[71px] py-2" />
              <Skeleton className="w-1/3 h-[71px] py-2" />
              <Skeleton className="w-1/3 h-[71px] py-2" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
